module.exports = __webpack_public_path__ + "img/baizhi-back-two@3x.44954f2c.png";